<template>
    <b-container class="bv-example-row">
        <alert :message="message" />
        <b-row>
            <b-col md="12">
                <h3>Dashboard</h3>
            </b-col>
        </b-row>

        <div v-if="files">
            <b>Creation time:</b> {{ files.creation_date }}
            <b-row>
                <b-col v-for="(value, name, index) in files.charts" :key="index" :md="index % 2 === 0 ? '6' : '6'">
                    {{ name }}
                    <apexchart width="500" :type="listOfAreaGraphs.indexOf(name) != -1 ? 'area' : 'bar'"
                        :options="listOfChartOptions[name]" :series="listOfSeries[name]">
                    </apexchart>
                </b-col>

            </b-row>
        </div>
    </b-container>
</template>

<script>
import Alert from '../components/alert.vue';

export default {
    data: function () {
        return {
            message: '',
            files: null,
            listOfChartOptions: {},
            listOfSeries: {},
            listOfAreaGraphs: ['analytics/5_traffic_weekly.json', 'analytics/6_registration_weekly.json'],
        }
    },
    methods: {
        init() {
            this.getFiles();
        },
        getFiles() {
            this.$http.get(this.$apiURL + '/analytic', { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.files = JSON.parse(res.data);
                    console.log(this.files.charts)
                    for (var key in this.files.charts) {
                        this.chartOptions = {
                            chart: {
                                id: 'vuechart-example'
                            },
                            xaxis: {
                                categories: []
                            }
                        };
                        this.series = [{
                            name: 'series-1',
                            data: []
                        },]

                        //console.log(this.files[key])
                        for (var x in this.files.charts[key]) {
                            this.chartOptions.xaxis.categories.push(x)
                            this.series[0].data.push(parseInt(this.files.charts[key][x]))

                            this.listOfChartOptions[key] = this.chartOptions
                            this.listOfSeries[key] = this.series

                        }
                    }
                })
                .catch((error) => {
                    console.log(error)
                    // this.message = error.response.data
                    // this.message.type = "danger"
                });
        },
    },
    components: {
        alert: Alert,
    },
    created() {
        this.init();
    }
};
</script>